import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-xxl-8 col-lg-7" }
const _hoisted_3 = { class: "col-xxl-4 col-lg-5" }
const _hoisted_4 = { class: "col-xxl-4 col-xl-6 col-md-6" }
const _hoisted_5 = { class: "col-xxl-4 col-xl-6 col-md-6" }
const _hoisted_6 = { class: "col-xxl-4 col-xl-6 col-md-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TrackingID = _resolveComponent("TrackingID")!
  const _component_RecentOrders = _resolveComponent("RecentOrders")!
  const _component_OrderSummary = _resolveComponent("OrderSummary")!
  const _component_BillingDetails = _resolveComponent("BillingDetails")!
  const _component_ShippingDetails = _resolveComponent("ShippingDetails")!
  const _component_DeliveryDetails = _resolveComponent("DeliveryDetails")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_TrackingID),
      _createVNode(_component_RecentOrders)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_OrderSummary)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_BillingDetails)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_ShippingDetails)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_component_DeliveryDetails)
    ])
  ]))
}